import { useLanguage } from '../../context/LanguageContext';
import { Link } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';

export default function TermsOfService() {
  const { language } = useLanguage();

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-10" data-testid="terms-of-service-page">
      <Link to="/" className="inline-flex items-center gap-1.5 text-sm text-[#1B3A7B] hover:underline mb-6">
        <ChevronLeft className="w-4 h-4" />
        {language === 'pl' ? 'Powrot do kalkulatora' : 'Back to calculator'}
      </Link>

      <h1 className="text-3xl sm:text-4xl font-heading font-bold text-[#1B3A7B] mb-8">
        {language === 'pl' ? 'Regulamin Serwisu' : 'Terms of Service'}
      </h1>

      <div className="prose prose-slate max-w-none space-y-6 text-sm leading-relaxed text-slate-700">
        <p className="text-slate-500 text-xs">Obowiazuje od: 15 lutego 2026 r.</p>

        <section>
          <h2 className="text-lg font-semibold text-[#1B3A7B] mt-6 mb-3">1. Postanowienia ogolne</h2>
          <p>1.1. Niniejszy Regulamin okresla zasady korzystania z serwisu internetowego dostepnego pod adresem <strong>kalkulatorkurdynowski.pl</strong> (dalej: &bdquo;Serwis&rdquo;).</p>
          <p>1.2. Wlascicielem i operatorem Serwisu jest <strong>Biuro Rachunkowe Kurdynowski</strong> (dalej: &bdquo;Uslugodawca&rdquo;).</p>
          <p>1.3. Kontakt z Uslugodawca: <a href="mailto:monika.gawkowska@kurdynowski.pl" className="text-[#1B3A7B] hover:underline">monika.gawkowska@kurdynowski.pl</a></p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-[#1B3A7B] mt-6 mb-3">2. Definicje</h2>
          <ul className="list-disc pl-6 space-y-1">
            <li><strong>Serwis</strong> &mdash; strona internetowa kalkulatorkurdynowski.pl wraz z kalkulatorem wyceny uslug ksiegowych</li>
            <li><strong>Uzytkownik</strong> &mdash; osoba fizyczna lub prawna korzystajaca z Serwisu</li>
            <li><strong>Kalkulator</strong> &mdash; narzedzie online do orientacyjnej wyceny uslug ksiegowych</li>
            <li><strong>Wycena</strong> &mdash; orientacyjna kalkulacja kosztow uslug ksiegowych wygenerowana przez Kalkulator</li>
          </ul>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-[#1B3A7B] mt-6 mb-3">3. Zakres uslug</h2>
          <p>3.1. Serwis umozliwia Uzytkownikom korzystanie z Kalkulatora wyceny uslug ksiegowych.</p>
          <p>3.2. Wycena generowana przez Kalkulator ma charakter orientacyjny i nie stanowi oferty handlowej w rozumieniu art. 66 Kodeksu cywilnego.</p>
          <p>3.3. Ostateczna cena uslug ksiegowych ustalana jest indywidualnie po kontakcie z Uslugodawca.</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-[#1B3A7B] mt-6 mb-3">4. Zasady korzystania z Serwisu</h2>
          <p>4.1. Korzystanie z Kalkulatora jest bezplatne.</p>
          <p>4.2. Uzytkownik zobowiazuje sie do podawania prawdziwych danych.</p>
          <p>4.3. Zabronione jest korzystanie z Serwisu w sposob naruszajacy przepisy prawa lub prawa osob trzecich.</p>
          <p>4.4. Uzytkownik moze dobrowolnie podac dane kontaktowe w celu otrzymania wyceny na e-mail lub nawiazania kontaktu z Uslugodawca.</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-[#1B3A7B] mt-6 mb-3">5. Odpowiedzialnosc</h2>
          <p>5.1. Uslugodawca doklada starannosci, aby dane prezentowane w Kalkulatorze byly aktualne i rzetelne.</p>
          <p>5.2. Uslugodawca nie ponosi odpowiedzialnosci za decyzje podjete na podstawie wyceny wygenerowanej przez Kalkulator.</p>
          <p>5.3. Uslugodawca nie odpowiada za przerwy w dzialaniu Serwisu wynikajace z przyczyn technicznych.</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-[#1B3A7B] mt-6 mb-3">6. Wlasnosc intelektualna</h2>
          <p>6.1. Wszelkie tresci zawarte w Serwisie, w tym teksty, grafiki, logotypy i oprogramowanie, sa chronione prawem autorskim.</p>
          <p>6.2. Prawa autorskie do serwisu, w tym do oprogramowania kalkulatora, naleza do <strong>Moniki Malgorzaty Gawkowskiej</strong> jako pomyslodawczyni i wykonawczyni.</p>
          <p>6.3. Kopiowanie, rozpowszechnianie lub wykorzystywanie tresci Serwisu bez zgody jest zabronione.</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-[#1B3A7B] mt-6 mb-3">7. Reklamacje</h2>
          <p>7.1. Reklamacje dotyczace funkcjonowania Serwisu nalezy zglaszac na adres: <a href="mailto:monika.gawkowska@kurdynowski.pl" className="text-[#1B3A7B] hover:underline">monika.gawkowska@kurdynowski.pl</a></p>
          <p>7.2. Uslugodawca rozpatrzy reklamacje w terminie 14 dni roboczych od jej otrzymania.</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-[#1B3A7B] mt-6 mb-3">8. Zmiany Regulaminu</h2>
          <p>8.1. Uslugodawca zastrzega sobie prawo do zmiany niniejszego Regulaminu.</p>
          <p>8.2. O zmianach Regulaminu Uzytkownicy beda informowani za posrednictwem Serwisu.</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-[#1B3A7B] mt-6 mb-3">9. Postanowienia koncowe</h2>
          <p>9.1. W sprawach nieuregulowanych niniejszym Regulaminem maja zastosowanie przepisy prawa polskiego.</p>
          <p>9.2. Ewentualne spory wynikajace z korzystania z Serwisu beda rozstrzygane przez sad wlasciwy dla siedziby Uslugodawcy.</p>
        </section>
      </div>
    </div>
  );
}
